module.exports = __webpack_public_path__ + "img/game--apex-legends--esrb.65c5e9f1.png";